import { useAuth } from "@/context/AuthProvider/useAuth";
import userExcursionApi from "@/services/api/UserExcursion";
import { useEffect, useState } from "react";

const useFetchUserExcursionFromUserId = () => {
  const { user } = useAuth();
  const { id: userId } = user;

  const [excursions, setExcursions] = useState(null);

  const fetchExcursionsFromUserExcursionsFromUserId = async () => {
    try {
      const { data } =
        await userExcursionApi.getUserExcursionsFromUserId(userId);

      const auxiliarExcursions = [];

      data.forEach((userExcursion) =>
        auxiliarExcursions.push({
          imagePreview: userExcursion.Excursion.imagePreview[0],
          createdAt: userExcursion.createdAt,
          excursionTitle: userExcursion.Excursion.title,
          excursionAgent: userExcursion.Excursion.agent,
          totalValue: userExcursion.totalValue,
          quantity: userExcursion.quantity + 1,
        })
      );

      setExcursions(auxiliarExcursions);
    } catch (error) {
      console.error(
        "Error fetching excursions from user excursions from a userId: ",
        error
      );
    }
  };

  useEffect(() => {
    fetchExcursionsFromUserExcursionsFromUserId();
  }, []);

  return { excursions };
};

export default useFetchUserExcursionFromUserId;
